import {api} from "../../../api/timesheetAPI";
import {formatHourString} from "./hourPrecision";

interface SaveWorklogArgs {
    jiraId: string;
    category: string;
    date: string;
    hours: number;
    comment?: string;
    impersonate: string;
}

/** POST worklog/save/nojira — adds a booking for a single JIRA id/day (script's saveWorklog). */
export async function saveWorklogEntry({jiraId, category, date, hours, comment, impersonate}: SaveWorklogArgs) {
    const payload: Record<string, unknown> = {
        jira_id: jiraId,
        category,
        overtime: false,
        dates: [date, date],
        time_logged: formatHourString(hours),
        impersonate
    };
    if (comment && comment.trim().length > 0) {
        payload.comment = comment.trim();
    }
    return api.addFromJirabutton(payload);
}

interface ClearBookingArgs {
    bookingId: string;
    status?: string;
    impersonate: string;
    newValue?: number;
}

/** PATCH worklog/update — sets an existing booking to a new hour value (script's clearBookingToZero). */
export async function updateBookingHours({bookingId, status, impersonate, newValue = 0}: ClearBookingArgs) {
    const payload: Record<string, unknown> = {
        db_booking_id: `${bookingId}+`,
        impersonate,
        [`time_logged_${bookingId}`]: newValue
    };
    if (status) {
        payload[`db_booking_status_${bookingId}`] = status;
    }
    return api.update(payload);
}
